import { Box, Grid, Heading, Text, VStack } from "@chakra-ui/react"
import { useQueryClient } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import type { UserPublic } from "@/client"
import Appearance from "@/components/UserSettings/Appearance"
import ChangePassword from "@/components/UserSettings/ChangePassword"
import DeleteAccount from "@/components/UserSettings/DeleteAccount"
import TwoStepVerification from "@/components/UserSettings/TwoStepVerification"
import UserInformation from "@/components/UserSettings/UserInformation"
import { VisionCard } from "@/components/VisionUI"
import { useSemanticColors } from "@/hooks/useSemanticColors"

export const Route = createFileRoute("/_layout/settings")({
  component: UserSettings,
})

function UserSettings() {
  const { t } = useTranslation("settings")
  const sc = useSemanticColors()
  const queryClient = useQueryClient()
  const currentUser = queryClient.getQueryData<UserPublic>(["currentUser"])

  return (
    <Box>
      <Box mb={{ base: 5, md: 8 }}>
        <Heading size={{ base: "lg", md: "xl" }} color={sc.heading} mb={2}>
          {t("title")}
        </Heading>
        <Text color={sc.textMuted} fontSize={{ base: "sm", md: "md" }}>
          {t("subtitle")}
        </Text>
      </Box>

      <Grid
        templateColumns={{ base: "1fr", lg: "3fr 1fr" }}
        gap={{ base: 4, md: 6 }}
      >
        <VStack gap={6} align="stretch">
          <VisionCard>
            <UserInformation />
          </VisionCard>

          <VisionCard>
            <ChangePassword />
          </VisionCard>

          <VisionCard>
            <TwoStepVerification />
          </VisionCard>
        </VStack>

        <VStack gap={6} align="stretch">
          <VisionCard>
            <Appearance />
          </VisionCard>

          {!currentUser?.is_superuser && (
            <VisionCard>
              <DeleteAccount />
            </VisionCard>
          )}
        </VStack>
      </Grid>
    </Box>
  )
}
